import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  ActualReturnSearch,
  ActualReturnSearchResult,
  ActualReturnSummaryResult,
  TrackingIdResponse,
  GetMissingTrackingData
} from "@/types/amazon/amazonActualReturn";

export const AmazonactualReturnApi = createApi({
  reducerPath: "AmazonactualReturnApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  keepUnusedDataFor: 0,
  tagTypes: ["amazonactualReturn"],
  endpoints: (builder) => ({
    uploadActualReturn: builder.mutation({
      query: ({ formData }) => ({
        url: `/amazon-actualReturn/actualreturn/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["amazonactualReturn"],
    }),
    searchActualReturn: builder.query<
      ActualReturnSearchResult,
      ActualReturnSearch
    >({
      query: (input) => ({
        url: `/amazon-actualReturn/search`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["amazonactualReturn"],
    }),
    exportActualReturn: builder.mutation<Blob, ActualReturnSearch>({
      query: (input) => ({
        url: `/amazon-actualReturn/search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryActualReturn: builder.query<
      ActualReturnSummaryResult,
      ActualReturnSearch
    >({
      query: (input) => ({
        url: `/amazon-actualReturn/summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["amazonactualReturn"],
    }),
    deleteActualReturns: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/amazon-actualReturn/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["amazonactualReturn"],
    }),
    getTrackingIdData: builder.query<TrackingIdResponse, void>({
      query: () => ({
        url: `/amazon-actualReturn/get-amazon/tracking-id`,
        method: "GET",
      }),
    }),

    addManualReturnStatus: builder.mutation<void, any>({
      query: (input) => ({
        url: `/amazon-actualReturn/create`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["amazonactualReturn"],
    }),
    getMissingData: builder.query<GetMissingTrackingData, void>({
      query: () => ({
        url: `/amazon-actualReturn/missing`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useUploadActualReturnMutation,
  useSearchActualReturnQuery,
  useLazySearchActualReturnQuery,
  useExportActualReturnMutation,
  useSummaryActualReturnQuery,
  useDeleteActualReturnsMutation,
  useLazyGetTrackingIdDataQuery,
  useAddManualReturnStatusMutation,
  useLazyGetMissingDataQuery,
  
} = AmazonactualReturnApi;
